import { createFileRoute, redirect } from "@tanstack/react-router";

// Dubblett av /en/video-agency-stockholm (identisk H1, båda i sitemap).
// Permanent omdirigering till den kanoniska engelska URL:en.
export const Route = createFileRoute("/english/video-agency-stockholm")({
  beforeLoad: () => {
    throw redirect({ to: "/en/video-agency-stockholm", replace: true, statusCode: 301 });
  },
});
